import React from 'react';
import { Link } from 'react-router-dom';
import Jumbotron from '../components/Jumbotron';

function OrderCancel() {
  return (
    <div>
      <Jumbotron>
        <h2>Your purchase was cancelled</h2>
        <p>
          You have not been charged. You can come back and check out your cart any time.
        </p>
        <div>
          <ul>
            <li><Link to="/">Go back home</Link></li>
            <li><Link to="/orderHistory">See your order history</Link></li>
          </ul>
        </div>
      </Jumbotron>
    </div>
  );
}

export default OrderCancel;
